<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <!-- 系统消息图标 -->
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div class="header-icon user-icon" @click="login">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端：左侧导航 外层容器包裹两个组件，不会横向铺开 -->
    <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="true" @openSubMenu="openSubMenu" />
    </div>
    <TopSide @openSubMenu="openSubMenu2" />
    <!-- 移动端左侧抽屉菜单 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide
        @openSubMenu="
          openSubMenu
          mobileMenuDrawer = false
        "
      />
    </el-drawer>

    <!-- 主体内容区域 -->
    <div class="main-content">
      <div class="main-content asset-page" :class="{ 'pc-offset': !isMobile }">
        <div class="page-top-title asset-title-row">
          <h1>我的资产</h1>
        </div>

        <!-- 统计卡片区域 -->
        <div class="asset-card-row">
          <div class="asset-stat-card" v-for="stat in assetStats" :key="stat.type">
            <div class="stat-left">
              <div class="stat-label">{{ stat.label }}</div>
              <div class="stat-number">{{ stat.count }}</div>
            </div>
            <div class="stat-icon">
              <i :class="stat.icon" :style="{ color: stat.color }"></i>
            </div>
          </div>
        </div>

        <!-- ==========【充值&会员模块 Tabs切换】========== -->
        <div class="recharge-wrap">
          <h3 class="block-title">充值 / 开通会员</h3>
          <el-tabs v-model="activePayTab">
            <!-- 积分充值 tab -->
            <el-tab-pane label="积分充值" name="recharge">
              <div class="recharge-card">
                <div class="tip-text">💡提示：生成下载一张原图消耗 <span class="text-red">12积分</span></div>
                <div class="recharge-quick">
                  <div class="recharge-amount-item" v-for="item in pointRechargeList" :key="item.key" :class="{ active: selectPayItem?.key === item.key }" @click="selectPayItem = item">
                    <div class="item-top">{{ item.money }}元</div>
                    <div class="item-bottom">赠送{{ item.point }}积分</div>
                  </div>
                </div>
                <div class="recharge-btn-row">
                  <el-button type="primary" size="large" :loading="rechargeLoading" @click="handleRecharge" :disabled="!selectPayItem"> 立即支付 </el-button>
                  <div v-if="!selectPayItem" class="tip-select">请选择充值档位</div>
                </div>
              </div>
            </el-tab-pane>

            <!-- 会员开通 tab -->
            <el-tab-pane label="开通会员" name="vip">
              <div class="recharge-card">
                <div class="tip-text">💡会员权益：生图可直接下载原图；非会员仅可免费下载2张原图</div>
                <div class="recharge-quick">
                  <div class="recharge-amount-item vip-item" v-for="item in vipRechargeList" :key="item.key" :class="{ active: selectPayItem?.key === item.key }" @click="selectPayItem = item">
                    <div class="item-top">{{ item.title }}</div>
                    <div class="item-bottom">{{ item.money }}元</div>
                  </div>
                </div>
                <div class="recharge-btn-row">
                  <el-button type="primary" size="large" :loading="rechargeLoading" @click="handleRecharge" :disabled="!selectPayItem"> 立即开通 </el-button>
                  <div v-if="!selectPayItem" class="tip-select">请选择会员档位</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 资产明细表格 -->
        <div class="asset-content-row">
          <div class="asset-table-wrap">
            <h3 class="block-title">资产明细</h3>
            <el-table :data="guestMingxi" height="550" :row-class-name="tableRowClassName">
              <el-table-column label="类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.mingxi_type === 1 ? '积分充值' : scope.row.mingxi_type === 2 ? '积分消费' : scope.row.mingxi_type === 3 ? '会员开通' : scope.row.mingxi_type }}</span>
                </template>
              </el-table-column>
              <el-table-column label="积分" prop="mingxi_money" />
              <el-table-column label="创建时间" prop="add_time" />
            </el-table>

            <div class="table-pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryMingxi.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryMingxi.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="queryMingxi.total" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== 微信扫码支付弹窗 ========== -->
    <el-dialog title="微信扫码支付" :visible.sync="payDialogVisible" width="420px" :close-on-click-modal="false" @close="onPayDialogClose">
      <div class="pay-qrcode-wrap">
        <div v-if="payQrCodeUrl">
          <p class="pay-tip">
            请使用微信扫一扫，支付
            <span class="money-text">¥{{ selectPayItem.money }}</span>
          </p>
          <!-- 二维码容器 -->
          <div id="qrcode-box" style="display: inline-block"></div>
          <p class="pay-time-tip">二维码有效期5分钟，请尽快完成支付</p>
        </div>
        <div v-else class="qr-loading">
          <i class="el-icon-loading"></i>
          <p>正在生成支付二维码...</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- ========== 大图预览弹窗 ========== -->
    <div class="preview-mask" v-if="previewVisible" @click.self="closePreview">
      <div class="preview-box">
        <i class="el-icon-close preview-close" @click="closePreview"></i>
        <img class="preview-img" :src="currentPreviewImg.src" alt="" />
        <div class="preview-toolbar">
          <el-button type="primary" size="small" @click="downloadImage"> <i class="el-icon-download"></i> 下载保存 </el-button>
        </div>
      </div>
    </div>

    <!-- ========== 右侧抽屉：电商图子菜单 ========== -->
    <el-drawer :visible.sync="subDrawerVisible" direction="rtl" size="260px" title="电商图设计" :before-close="closeSubDrawer">
      <div class="sub-menu-list">
        <div class="sub-menu-item" v-for="subItem in subMenuList" :key="subItem.path" @click="goPage(subItem.path)">
          <i :class="subItem.icon"></i>
          <span>{{ subItem.title }}</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

import LeftSide from '@/components/LeftSide.vue'
import TopSide from '@/components/TopSide.vue'

export default {
  components: { LeftSide, TopSide },
  data() {
    return {
      isMobile: false,
      mobileSideVisible: false,
      mobileMenuDrawer: false,
      previewVisible: false,
      currentPreviewImg: { src: '' },
      showBottomInput: true,

      guest_mob: '',
      guestMingxi: [],
      queryInfo: {
        C_type: 'get_guestInfo',
        guest_mob: ''
      },
      queryMingxi: {
        C_type: 'get_list',
        C_table_name: 'guestmingxi_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      subDrawerVisible: false,
      visible_loginMenu: false,
      subMenuList: [
        { title: '商品主图', icon: 'el-icon-picture', path: '/shop/main' },
        { title: '详情页设计', icon: 'el-icon-document', path: '/shop/detail' },
        { title: '场景效果图', icon: 'el-icon-s-platform', path: '/shop/scene' },
        { title: '批量修图', icon: 'el-icon-s-tools', path: '/shop/batch' }
      ],
      assetStats: [
        { label: '总余额', count: 0, icon: 'el-icon-wallet', color: '#4096ff' },
        { label: '总积分', count: 0, icon: 'el-icon-coin', color: '#4096ff' },
        { label: '已消费', count: 0, icon: 'el-icon-shopping-cart-2', color: '#4096ff' }
      ],

      // =========【充值会员配置】=========
      activePayTab: 'recharge',
      // 积分充值档位（来自后台「充值设置」，见 getChongzhiConfig）
      pointRechargeList: [],
      // 会员档位（来自后台「充值设置」，见 getChongzhiConfig）
      vipRechargeList: [],
      configLoading: false,
      selectPayItem: null, // 选中的档位对象
      rechargeLoading: false,
      payDialogVisible: false,
      payQrCodeUrl: '',
      currentOrderNo: '',
      payPollTimer: null
    }
  },
  watch: {
    payDialogVisible(val) {
      if (val) {
        this.drawQrCode()
      } else {
        const box = document.getElementById('qrcode-box')
        if (box) box.innerHTML = ''
      }
    },
    payQrCodeUrl() {
      this.drawQrCode()
    }
  },
  created() {
    const token = window.sessionStorage.getItem('token')
    this.visible_loginMenu = !!token
    this.guest_mob = window.sessionStorage.getItem('guest_mob')
    this.queryInfo.guest_mob = this.guest_mob
    this.getGuestMingxi()
    this.getGuestInfo()
    this.getChongzhiConfig()
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    if (this.payPollTimer) clearInterval(this.payPollTimer)
  },
  methods: {
    drawQrCode() {
      console.log('进入绘制二维码，payQrCodeUrl=', this.payQrCodeUrl)
      this.$nextTick(() => {
        const box = document.getElementById('qrcode-box')
        console.log('获取dom容器：', box)
        if (!box || !this.payQrCodeUrl) {
          console.log('缺少dom或者二维码链接，终止绘制')
          return
        }
        box.innerHTML = ''
        const qr = new QRCode(box, {
          text: this.payQrCodeUrl,
          width: 220,
          height: 220
        })
        console.log('二维码绘制完成')
      })
    },
    tableRowClassName({ row }) {
      if (Number(row.mingxi_money) < 0) {
        return 'row-minus-red'
      }
      return ''
    },
    openSubMenu2() {
      this.subDrawerVisible = true
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) this.mobileSideVisible = false
    },
    handleSizeChange(val) {
      this.queryMingxi.pageSize = val
      this.queryMingxi.pageNum = 1
      this.getGuestMingxi()
    },
    handleCurrentChange(val) {
      this.queryMingxi.pageNum = val
      this.getGuestMingxi()
    },
    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'setting':
          this.$router.push('/user/setting')
          break
        case 'logout':
          this.$message.success('退出登录成功')
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('guest_mob')
          this.visible_loginMenu = false
          this.$router.push('/mob')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    closeSubDrawer(done) {
      done()
    },
    goPage(routePath) {
      this.$router.push(routePath)
      this.subDrawerVisible = false
    },
    closePreview() {
      this.previewVisible = false
    },
    downloadImage() {},

    async getGuestInfo() {
      try {
        const { data: res } = await this.$http.get('get_api', { params: this.queryInfo })
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0) return
        this.assetStats[0].count = resData[0].yue || 0
        this.assetStats[1].count = resData[0].guest_accout_chongzhi || 0
        this.assetStats[2].count = resData[0].guest_accout_xiaofei || 0
      } catch (err) {
        console.error('资产接口请求失败', err)
      }
    },
    async getGuestMingxi() {
      try {
        const { data: res } = await this.$http.get('get_api', { params: this.queryMingxi })
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0) {
          this.guestMingxi = []
          this.queryMingxi.total = 0
          return
        }
        this.guestMingxi = resData[0].dataList || []
        this.queryMingxi.total = resData[0].total
      } catch (err) {
        console.error('资产接口请求失败', err)
      }
    },

    // ===================== 充值档位（后台「充值设置」维护） =====================
    async getChongzhiConfig() {
      this.configLoading = true
      try {
        const [pointRes, vipRes] = await Promise.all([
          this.$http.get('get_api', { params: { C_type: 'chongzhi_config_list', config_type: 1 } }),
          this.$http.get('get_api', { params: { C_type: 'chongzhi_config_list', config_type: 2 } })
        ])
        this.pointRechargeList = this.mapConfig(pointRes.data)
        this.vipRechargeList = this.mapConfig(vipRes.data)
        // 档位变化后清掉旧的选中项，避免金额对不上
        if (this.selectPayItem && !this.pointRechargeList.concat(this.vipRechargeList).some((i) => i.key === this.selectPayItem.key)) {
          this.selectPayItem = null
        }
      } catch (err) {
        console.error('充值档位接口请求失败', err)
      } finally {
        this.configLoading = false
      }
    },
    // 把接口返回的档位转成页面使用的结构
    mapConfig(res) {
      try {
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0 || resData[0].status !== 200) return []
        const list = resData[0].dataList || []
        return list.map((item) => ({
          uid: item.uid,
          key: item.config_key,
          title: item.config_title,
          money: Number(item.config_money),
          point: Number(item.config_point || 0),
          month: Number(item.config_month || 0),
          desc: item.config_desc || ''
        }))
      } catch (e) {
        console.error('充值档位解析失败', e)
        return []
      }
    },

    // ===================== 充值/会员支付 =====================
    async handleRecharge() {
      if (!this.selectPayItem) {
        return this.$message.warning('请选择档位')
      }
      const amountYuan = Number(this.selectPayItem.money)
      const amountCent = Math.round(amountYuan * 100) // 转为分传给后端
      const payType = this.activePayTab

      this.rechargeLoading = true
      this.payQrCodeUrl = ''
      this.currentOrderNo = ''
      try {
        const { data } = await this.$http.post('/api/wxpay/createRecharge', {
          appid: 'wx3c41329c4790de7f', // 小写appid！！
          amount: amountCent,
          payType: payType,
          configKey: this.selectPayItem.key, // 后端以数据库档位配置为准核价
          payItem: this.selectPayItem
        })
        if (data.code !== 200) {
          this.$message.error(data.msg || '创建订单失败')
          return
        }
        // ========= 后端返回 qrCodeUrl 和 orderNo =========
        this.currentOrderNo = data.data.orderNo
        this.payQrCodeUrl = data.data.qrCodeUrl
        this.payDialogVisible = true
        this.startPollPayStatus()
      } catch (e) {
        console.error('发起支付失败', e)
        this.$message.error('发起支付失败')
      } finally {
        this.rechargeLoading = false
      }
    },
    startPollPayStatus() {
      if (this.payPollTimer) clearInterval(this.payPollTimer)
      this.payPollTimer = setInterval(async () => {
        if (!this.currentOrderNo) return
        try {
          const { data } = await this.$http.get('/api/wxpay/queryPay', {
            params: { orderNo: this.currentOrderNo }
          })
          if (data.code === 200 && data.data.status === 'success') {
            clearInterval(this.payPollTimer)
            this.$message.success('支付成功！')
            this.payDialogVisible = false
            this.selectPayItem = null
            // 刷新资产、明细
            this.getGuestInfo()
            this.getGuestMingxi()
          }
          if (data.data.status === 'closed' || data.data.status === 'expire') {
            clearInterval(this.payPollTimer)
            this.$message.info('订单已超时或关闭')
            this.payDialogVisible = false
          }
        } catch (err) {
          console.log('查询支付状态异常', err)
        }
      }, 2000)
    },
    onPayDialogClose() {
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer)
        this.payPollTimer = null
      }
      this.currentOrderNo = ''
      this.payQrCodeUrl = ''
    }
  }
}
</script>

<style scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
}

.header-left {
  display: flex;
  align-items: center;
}

.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
  position: relative;
  z-index: 101;
  pointer-events: auto !important;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
  transition: 0.2s;
}

.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

/* 充值模块 */
.recharge-wrap {
  margin-bottom: 24px;
}

.recharge-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  border: 1px solid #e8edf2;
}

.tip-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.text-red {
  color: #f53f3f;
  font-weight: bold;
}

.recharge-quick {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.recharge-amount-item {
  min-width: 130px;
  text-align: center;
  padding: 14px 12px;
  border: 1px solid #e8edf2;
  border-radius: 8px;
  cursor: pointer;
}

.recharge-amount-item.vip-item {
  min-width: 140px;
}

.recharge-amount-item.active {
  border-color: #22b8e6;
  background: #f0f9fe;
}

.item-top {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-bottom: 4px;
}

.item-bottom {
  font-size: 14px;
  color: #666;
}

.recharge-btn-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tip-select {
  color: #999;
  font-size: 13px;
}

/* 扫码弹窗 */
.pay-qrcode-wrap {
  text-align: center;
  padding: 10px 0;
}

.pay-tip {
  font-size: 15px;
  margin-bottom: 16px;
}

.money-text {
  color: #f53f3f;
  font-weight: bold;
}

.pay-time-tip {
  margin-top: 12px;
  font-size: 13px;
  color: #999;
}

.qr-loading {
  padding: 40px 0;
  color: #666;
}

#qrcode-box {
  margin: 0 auto;
}

.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.sub-menu-list {
  padding-top: 12px;
}

.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}

.sub-menu-item:hover {
  background: #f0f9fe;
  color: #22b8e6;
}

.sub-menu-item i {
  font-size: 16px;
}

.float-input-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px 24px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 1;
  transform: translateY(0);
}

.float-input-panel.hidePanel {
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
}

.float-input-box {
  width: 100%;
  max-width: 820px;
  background: #ffffff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.float-input-left {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.float-add-icon {
  color: #999;
  font-size: 16px;
}

.float-textarea {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 42px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.float-textarea::placeholder {
  color: #999;
}

.float-input-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.float-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #dde5ee;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #22b8e6;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn:hover {
  background: #1ea3cc;
}

.float-quick-tags {
  width: 100%;
  max-width: 820px;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.quick-tag {
  font-size: 13px;
  color: #666;
  background: #f5f7fa;
  border: 1px solid #e8edf2;
  border-radius: 20px;
  padding: 6px 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.quick-tag:hover {
  color: #22b8e6;
  border-color: #ccebfa;
  background: #f0f9fe;
}

.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}

.main-content {
  flex: 1;
  padding: 30px 20px;
  box-sizing: border-box;
}

.page-top-title {
  text-align: center;
  margin-bottom: 26px;
}

.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}

.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}

.preview-box {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-close {
  position: absolute;
  top: -36px;
  right: 0;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}

.preview-img {
  max-width: 100%;
  max-height: 82vh;
  border-radius: 6px;
  display: block;
}

.preview-toolbar {
  text-align: center;
  margin-top: 14px;
}

.asset-card-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.asset-stat-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e8edf2;
}

.stat-label {
  font-size: 15px;
  color: #666;
  margin-bottom: 6px;
}

.stat-number {
  font-size: 32px;
  font-weight: 500;
  color: #222;
}

.stat-icon i {
  font-size: 36px;
}

.asset-content-row {
  display: grid;
  grid-template-columns: 100%;
  gap: 16px;
}

.block-title {
  font-size: 17px;
  color: #222;
  margin: 0 0 14px;
  font-weight: 500;
}

.asset-table-wrap {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  border: 1px solid #e8edf2;
}

.table-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/*响应式*/
@media (max-width: 1024px) {
  .asset-card-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 0 16px;
  }

  .page-wrap {
    padding-top: 56px;
  }

  .main-content {
    padding: 20px 16px;
  }

  .asset-card-row {
    grid-template-columns: 1fr;
  }

  .stat-number {
    font-size: 26px;
  }

  .recharge-quick {
    justify-content: center;
  }

  .recharge-btn-row {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
